/**
 * @license
 * Copyright (c) 2018-present, Loomble Inc <opensource@loomble.com>
 * Copyright (c) 2018-preset, Jay Rylan <jay@jayrylan.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Included documentation uses material from the Wikipedia article
 * [List_of_HTTP_status_codes][List of HTTP status codes], which is released
 * under the [CC-BY-SA3][Creative Commons Attribution-Share-Alike License 3.0].
 *
 * [List_of_HTTP_status_codes]: https://en.wikipedia.org/wiki/List_of_HTTP_status_codes
 * [CC-BY-SA3]: https://creativecommons.org/licenses/by-sa/3.0/
 */

let StatusCode;

(function (StatusCode) {
  StatusCode[StatusCode["ClientErrorBadRequest"] = 400] = "ClientErrorBadRequest";
  StatusCode[StatusCode["ClientErrorConflict"] = 409] = "ClientErrorConflict";
  StatusCode[StatusCode["ClientErrorExpectationFailed"] = 417] = "ClientErrorExpectationFailed";
  StatusCode[StatusCode["ClientErrorFailedDependency"] = 424] = "ClientErrorFailedDependency";
  StatusCode[StatusCode["ClientErrorForbidden"] = 403] = "ClientErrorForbidden";
  StatusCode[StatusCode["ClientErrorGone"] = 410] = "ClientErrorGone";
  StatusCode[StatusCode["ClientErrorImATeapot"] = 418] = "ClientErrorImATeapot";
  StatusCode[StatusCode["ClientErrorLengthRequired"] = 411] = "ClientErrorLengthRequired";
  StatusCode[StatusCode["ClientErrorLocked"] = 423] = "ClientErrorLocked";
  StatusCode[StatusCode["ClientErrorLoginTimeOut"] = 440] = "ClientErrorLoginTimeOut";
  StatusCode[StatusCode["ClientErrorMethodNotAllowed"] = 405] = "ClientErrorMethodNotAllowed";
  StatusCode[StatusCode["ClientErrorMisdirectedRequest"] = 421] = "ClientErrorMisdirectedRequest";
  StatusCode[StatusCode["ClientErrorNotAcceptable"] = 406] = "ClientErrorNotAcceptable";
  StatusCode[StatusCode["ClientErrorNotFound"] = 404] = "ClientErrorNotFound";
  StatusCode[StatusCode["ClientErrorPayloadTooLarge"] = 413] = "ClientErrorPayloadTooLarge";
  StatusCode[StatusCode["ClientErrorPaymentRequired"] = 402] = "ClientErrorPaymentRequired";
  StatusCode[StatusCode["ClientErrorPreconditionFailed"] = 412] = "ClientErrorPreconditionFailed";
  StatusCode[StatusCode["ClientErrorPreconditionRequired"] = 428] = "ClientErrorPreconditionRequired";
  StatusCode[StatusCode["ClientErrorProxyAuthRequired"] = 407] = "ClientErrorProxyAuthRequired";
  StatusCode[StatusCode["ClientErrorRangeNotSatisfiable"] = 416] = "ClientErrorRangeNotSatisfiable";
  StatusCode[StatusCode["ClientErrorRequestHeaderFieldsTooLarge"] = 431] = "ClientErrorRequestHeaderFieldsTooLarge";
  StatusCode[StatusCode["ClientErrorRequestTimeout"] = 408] = "ClientErrorRequestTimeout";
  StatusCode[StatusCode["ClientErrorRetryWith"] = 449] = "ClientErrorRetryWith";
  StatusCode[StatusCode["ClientErrorTooManyRequests"] = 429] = "ClientErrorTooManyRequests";
  StatusCode[StatusCode["ClientErrorUnauthorized"] = 401] = "ClientErrorUnauthorized";
  StatusCode[StatusCode["ClientErrorUnavailableForLegalReasons"] = 451] = "ClientErrorUnavailableForLegalReasons";
  StatusCode[StatusCode["ClientErrorUnprocessableEntity"] = 422] = "ClientErrorUnprocessableEntity";
  StatusCode[StatusCode["ClientErrorUnsupportedMediaType"] = 415] = "ClientErrorUnsupportedMediaType";
  StatusCode[StatusCode["ClientErrorUpgradeRequired"] = 426] = "ClientErrorUpgradeRequired";
  StatusCode[StatusCode["ClientErrorURITooLong"] = 414] = "ClientErrorURITooLong";
  StatusCode[StatusCode["InfoContinue"] = 100] = "InfoContinue";
  StatusCode[StatusCode["InfoProcessing"] = 102] = "InfoProcessing";
  StatusCode[StatusCode["InfoSwitchingProtocols"] = 101] = "InfoSwitchingProtocols";
  StatusCode[StatusCode["RedirectFound"] = 302] = "RedirectFound";
  StatusCode[StatusCode["RedirectMovedPermanently"] = 301] = "RedirectMovedPermanently";
  StatusCode[StatusCode["RedirectMultipleChoices"] = 300] = "RedirectMultipleChoices";
  StatusCode[StatusCode["RedirectNotModified"] = 304] = "RedirectNotModified";
  StatusCode[StatusCode["RedirectPermanent"] = 308] = "RedirectPermanent";
  StatusCode[StatusCode["RedirectSeeOther"] = 303] = "RedirectSeeOther";
  StatusCode[StatusCode["RedirectSwitchProxy"] = 306] = "RedirectSwitchProxy";
  StatusCode[StatusCode["RedirectTemp"] = 307] = "RedirectTemp";
  StatusCode[StatusCode["RedirectUseProxy"] = 305] = "RedirectUseProxy";
  StatusCode[StatusCode["ServerErrorBadGateway"] = 502] = "ServerErrorBadGateway";
  StatusCode[StatusCode["ServerErrorBandwidthLimitExceeded"] = 509] = "ServerErrorBandwidthLimitExceeded";
  StatusCode[StatusCode["ServerErrorGatewayTimeout"] = 504] = "ServerErrorGatewayTimeout";
  StatusCode[StatusCode["ServerErrorHTTPVersionNotSupported"] = 505] = "ServerErrorHTTPVersionNotSupported";
  StatusCode[StatusCode["ServerErrorInsufficientStorage"] = 507] = "ServerErrorInsufficientStorage";
  StatusCode[StatusCode["ServerErrorInternal"] = 500] = "ServerErrorInternal";
  StatusCode[StatusCode["ServerErrorLoopDetected"] = 508] = "ServerErrorLoopDetected";
  StatusCode[StatusCode["ServerErrorNetworkAuthRequired"] = 511] = "ServerErrorNetworkAuthRequired";
  StatusCode[StatusCode["ServerErrorNotExtended"] = 510] = "ServerErrorNotExtended";
  StatusCode[StatusCode["ServerErrorNotImplemented"] = 501] = "ServerErrorNotImplemented";
  StatusCode[StatusCode["ServerErrorServiceUnavailable"] = 503] = "ServerErrorServiceUnavailable";
  StatusCode[StatusCode["ServerErrorVariantAlsoNegotiates"] = 506] = "ServerErrorVariantAlsoNegotiates";
  StatusCode[StatusCode["SuccessAccepted"] = 202] = "SuccessAccepted";
  StatusCode[StatusCode["SuccessAlreadyReported"] = 208] = "SuccessAlreadyReported";
  StatusCode[StatusCode["SuccessCreated"] = 201] = "SuccessCreated";
  StatusCode[StatusCode["SuccessIMUsed"] = 229] = "SuccessIMUsed";
  StatusCode[StatusCode["SuccessMultiStatus"] = 207] = "SuccessMultiStatus";
  StatusCode[StatusCode["SuccessNoContent"] = 204] = "SuccessNoContent";
  StatusCode[StatusCode["SuccessNonAuthoritativeInfo"] = 203] = "SuccessNonAuthoritativeInfo";
  StatusCode[StatusCode["SuccessOK"] = 200] = "SuccessOK";
  StatusCode[StatusCode["SuccessPartialContent"] = 206] = "SuccessPartialContent";
  StatusCode[StatusCode["SuccessResetContent"] = 205] = "SuccessResetContent";
})(StatusCode || (StatusCode = {}));

var StatusCode$1 = StatusCode;

export default StatusCode$1;
export { StatusCode };
